import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"

import type { ConfirmDialogProps } from "./types"
import { IconButton, Stack } from "@mui/material"
import { Iconify } from "../iconify"

// ----------------------------------------------------------------------

export function ConfirmDialog({
    title,
    content,
    action,
    open,
    onClose,
    invertActions,
    cancelButtonText = "Cancel",
    cancelVariant = "outlined",
    cancelColor = "inherit",
    ...other
}: ConfirmDialogProps & {
    invertActions?: boolean
    cancelButtonText?: string
    cancelVariant?: "outlined" | "contained"
    cancelColor?: "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning"
}) {
    return (
        <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
            <DialogTitle sx={{ pb: 2, borderBottom: "1px solid #DFE1E6", display: "flex", alignItems: "center" }}>
                {title}
                <IconButton onClick={onClose} sx={{ ml: "auto", mr: "-10px", mt: "-10px" }}>
                    <Iconify icon="mdi:close" />
                </IconButton>
            </DialogTitle>

            {content && (
                <DialogContent sx={{ typography: "body2", padding: "24px", paddingTop: "24px !important" }}>
                    {content}
                </DialogContent>
            )}

            <DialogActions sx={{ borderTop: "1px solid #DFE1E6" }}>
                <Stack direction="row" spacing={1} sx={{ flexDirection: invertActions ? "row-reverse" : "row" }}>
                    {action}

                    <Button variant={cancelVariant} color={cancelColor} onClick={onClose}>
                        {cancelButtonText}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    )
}
